/**
* Logo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'logo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( function() {
        $( '.logo-marquee' ).each( function() {
          const section = $( this );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( '.logo-slide' );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );
          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                $( '.logo__slider' ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }
          if ( section.find( '.logo-slide' ).length > 1 ) {
            section.find( '.logo__slider' ).slick( {
              slidesToShow: 4.5,
              slidesToScroll: 1,
              speed: 3000,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 0,
              centerMode: false,
              infinite: true,
              cssEase: 'linear',
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3.5,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                  },
                },
              ],
            } );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
